"use strict";

require("core-js/modules/es6.array.filter.js");

var _typeof = require("@babel/runtime-corejs2/helpers/typeof");

var _Reflect$construct = require("@babel/runtime-corejs2/core-js/reflect/construct");

var _Object$keys = require("@babel/runtime-corejs2/core-js/object/keys");

var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");

var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors");

var _Object$defineProperties = require("@babel/runtime-corejs2/core-js/object/define-properties");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

var _WeakMap = require("@babel/runtime-corejs2/core-js/weak-map");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.withProps = exports.getPxValueFromDT = exports.getHeightBySize = void 0;

var _parseInt2 = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/parse-int"));

var _isString2 = _interopRequireDefault(require("lodash/isString"));

require("core-js/modules/es6.function.bind.js");

require("core-js/modules/es6.regexp.replace.js");

var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));

var _each2 = _interopRequireDefault(require("lodash/each"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _newArrowCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/newArrowCheck"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _emotionTheming = require("emotion-theming");

var _theme = _interopRequireDefault(require("@ucloud-fe/react-components/lib/components/ThemeProvider/theme"));

var _this3 = void 0;

function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { _Object$defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var withProps = function withProps() {
  var _this = this;

  var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function (Comp) {
    (0, _newArrowCheck2["default"])(this, _this);
    var cleanProps = option.cleanProps;

    var ComponentWithProps = /*#__PURE__*/function (_Component) {
      (0, _inherits2["default"])(ComponentWithProps, _Component);

      var _super = _createSuper(ComponentWithProps);

      function ComponentWithProps() {
        (0, _classCallCheck2["default"])(this, ComponentWithProps);
        return _super.apply(this, arguments);
      }

      (0, _createClass2["default"])(ComponentWithProps, [{
        key: "render",
        value: function render() {
          var _this2 = this;

          var props = this.props;
          input = typeof input === "function" ? input(props) : input;
          var _input = input,
              className = _input.className;

          if (className) {
            className = typeof className === "function" ? className(props) : className;
          } // eslint-disable-next-line react/prop-types


          className = (0, _classnames["default"])(className, props.className);

          var result = _objectSpread(_objectSpread(_objectSpread({}, input), props), {}, {
            className: className
          });

          if (cleanProps) {
            (0, _each2["default"])(cleanProps, function (prop) {
              (0, _newArrowCheck2["default"])(this, _this2);
              return delete result[prop];
            }.bind(this));
          }

          if ((0, _isEmpty2["default"])(result.theme)) {
            result.theme = _theme["default"];
          }

          if (result._innerRef) {
            result.ref = result._innerRef;
            delete result._innerRef;
          }

          return /*#__PURE__*/_react["default"].createElement(Comp, result);
        }
      }]);
      return ComponentWithProps;
    }(_react.Component);

    return (0, _emotionTheming.withTheme)(ComponentWithProps);
  }.bind(this);
};

exports.withProps = withProps;

var getPxValueFromDT = function getPxValueFromDT(dt) {
  (0, _newArrowCheck2["default"])(this, _this3);
  return (0, _isString2["default"])(dt) && /^\d+px$/.test(dt) ? (0, _parseInt2["default"])(dt.replace("px", "")) : 0;
}.bind(void 0);

exports.getPxValueFromDT = getPxValueFromDT;
var SIZE_MAP = {
  sm: "T_HEIGHT_SM",
  md: "T_HEIGHT_MD",
  lg: "T_HEIGHT_LG"
};

var getHeightBySize = function getHeightBySize(DT) {
  var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "md";
  var token = SIZE_MAP[size];
  return DT[token];
};

exports.getHeightBySize = getHeightBySize;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ucloud/ui-components/lib/utils/index.js
// module id = 1196
// module chunks = 6 7 17 18